import { connectRouter } from "connected-react-router";
import { AnyAction, combineReducers, Reducer } from "redux";
import categoryReducer, { ICategoryState } from "src/redux/category/reducer";
import headerReducer, { IHeaderState } from "src/redux/header/reducer";
import searchReducer, { ISearchState } from "src/redux/search/reducer";

import t2sReducer, {
  IT2SState,
} from "../hoc/repository/withT2sProducts/redux/reducer";
import history from "../lib/history";
import { IUrlState } from "../types/global";

export interface IAppState {
  category: ICategoryState;
  search: ISearchState;
  header: IHeaderState;
  t2s: IT2SState;
  url: IUrlState;
}

export const initialState: IUrlState = {
  url: "",
};

const urlReducer: Reducer<IUrlState> = (
  state: IUrlState = initialState,
  action: AnyAction
): IUrlState => {
  if (action.type === "URL_STATE_RECEIVED") {
    return {
      ...action.payload,
    };
  }

  return state;
};

export default combineReducers({
  category: categoryReducer,
  search: searchReducer,
  header: headerReducer,
  router: connectRouter(history),
  t2s: t2sReducer,
  url: urlReducer,
});
